import { useDispatch, useSelector } from 'react-redux';
import BaseSelect from 'lib/BaseSelect';
import { Label } from 'lib/Label';

import { codeNameProductCategoryExclusivity } from 'consts/productCategoryExclusivityOptions';
import {
  DirectSalesProductCategoryExclusivityLabel,
  DirectSalesProductCategoryExclusivityType,
} from 'components/common/types/DirectSalesCampaign.types';

import { InputSize } from 'components/common/types/Input.types';
import { Padding as BaseSelectPadding } from 'lib/BaseSelect/BaseSelect.types';
import { CodeNameModel } from 'components/common/types';
import { Store } from 'components/common/types/Store.types';
import { changeDealData } from 'store/dealManagement/reducer';

const ProductCategoryExclusivity: React.FC = () => {
  const dispatch = useDispatch();
  const selectedValue = useSelector((state: Store) => state.dealManagement.commonDeal.productCategoryExclusivity);

  const onSelect = (value: DirectSalesProductCategoryExclusivityType): void => {
    dispatch(changeDealData({ productCategoryExclusivity: value }));
  };

  return (
    <div className="flex justify-between items-center py-1.5 border-b border-neutral-950-opacity-10">
      <Label id="product-category-exclusivity" label="Product category exclusivity" className="mb-0" />
      <div className="w-[167px]">
        <BaseSelect
          name="productCategoryExclusivity"
          dataTestId="product-category-exclusivity-select"
          options={codeNameProductCategoryExclusivity}
          selectedValue={{
            code: selectedValue,
            name: DirectSalesProductCategoryExclusivityLabel[selectedValue],
          }}
          size={InputSize.SMALL}
          onSelect={(_, value: CodeNameModel) => onSelect(value.code as DirectSalesProductCategoryExclusivityType)}
          padding={BaseSelectPadding.NONE}
        />
      </div>
    </div>
  );
};

export default ProductCategoryExclusivity;
